"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CommonElements;
const react_1 = __importDefault(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const faHeart_1 = require("@fortawesome/free-solid-svg-icons/faHeart");
const react_router_dom_1 = require("react-router-dom");
function CommonElements({ data, onThankYouClick, headerSubtitle = data.header_subtitle, giveLink }) {
    const initialItem = react_1.default.useRef(null);
    const { pathname } = (0, react_router_dom_1.useLocation)();
    react_1.default.useEffect(() => { var _a; return (_a = initialItem.current) === null || _a === void 0 ? void 0 : _a.focus(); }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        pathname.startsWith('/k12') ? (react_1.default.createElement("img", { className: "k12-header-image", src: '/dist/images/k12/download-resource.jpg', alt: "", width: "240" })) : (react_1.default.createElement("img", { className: "header-image", src: data.header_image, alt: "", height: "165", width: "165" })),
        react_1.default.createElement("p", null,
            react_1.default.createElement("span", { className: "header-title" }, data.header_title),
            react_1.default.createElement("br", null),
            react_1.default.createElement("span", null, headerSubtitle)),
        react_1.default.createElement("div", { className: "button-row" },
            react_1.default.createElement("a", { href: giveLink, className: "btn primary", onClick: OpenGiveInNewWindow, "data-nudge-action": "interacted", ref: initialItem },
                data.give_link_text,
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faHeart_1.faHeart })),
            react_1.default.createElement("a", { href: data.thank_you_link, className: "btn secondary", onClick: onThankYouClick, "data-nudge-action": "thank-you" }, data.thank_you_link_text)),
        react_1.default.createElement("p", { className: "giving-optional" }, data.giving_optional),
        react_1.default.createElement("hr", null)));
}
function OpenGiveInNewWindow(event) {
    event.preventDefault();
    const url = event.target.href;
    const { innerWidth, innerHeight } = window;
    const w = 0.8 * innerWidth;
    const h = 0.8 * innerHeight;
    window.open(url, 'givewindow', `menubar=0,width=${w},height=${h}`);
}
